var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"loading",style:({'position': _vm.type}),attrs:{"id":"loadingBox"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }